import HttpClient from "../../../core/HttpClient";
import { ISuggestion } from "./ISuggestion";

export class FinderService {

  private httpClient: HttpClient<ISuggestion>;
  constructor() {
    const baseURL = window.location.origin + "/wp-json/wizard/v1";
    this.httpClient = new HttpClient<ISuggestion>(baseURL);
  }
  public getAddresses(input: String): Promise<ISuggestion[]> {
    return this.httpClient.get<ISuggestion[]>(`/address?q=${input}`);
  }

  public saveContact(input: any): boolean {
    try {
      this.httpClient.post(`/contact`, input);
      return true;
    } catch (error) {
      return false;
    }

  }
}